// src/Contexts/mask.context.jsx
import React, { createContext, useContext, useMemo, useState } from "react";

const MaskContext = createContext(null);

export const MaskProvider = ({ children }) => {
  const [showMask, setShowMask] = useState(false);

  const value = useMemo(
    () => ({
      showMask,
      setShowMask,
      mask: () => setShowMask(true),
      unmask: () => setShowMask(false),
      toggleMask: () => setShowMask(v => !v),
    }),
    [showMask]
  );

  return <MaskContext.Provider value={value}>{children}</MaskContext.Provider>;
};

export const useMask = () => useContext(MaskContext);
